import React, {useEffect, useState} from 'react'
import '../../assets/scss/pages/authentication.scss'
import {
  DIVAY_URL,
  IMAGE, LOGIN_STATUS,
} from '../../configs/app-configs'
import {useDispatch, useSelector} from "react-redux";
import {loginAction} from "../../redux/actions/auth";
import {FormattedMessage} from "react-intl";
import {Button} from "reactstrap";


const AutoLogin = () => {

  const dispatch = useDispatch();
  const {loginStatus, errorMessage} = useSelector(state => state.auth);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const userId = queryParams.get('userId');
    const hmac = queryParams.get('hmac');
    const insId = queryParams.get('insId');
    dispatch(loginAction(userId, hmac, insId))
  }, [])

  const onClickGoBackHome = () => {
    sessionStorage.clear();
    window.location.href = DIVAY_URL;
  }

  return (
    <div className='fallback-spinner auto-login'>
      <img className="fallback-logo" src={IMAGE.LOGO} alt="logo"/>
      {
        loginStatus === '' ? (
          <React.Fragment>
            <div className='loading'>
              <div className='effect-1 effects'/>
              <div className='effect-2 effects'/>
              <div className='effect-3 effects'/>
            </div>
            <div className="login-waiting"><h3><FormattedMessage id='login.loggingIn'/></h3></div>
          </React.Fragment>
        ) : (
          loginStatus === LOGIN_STATUS.FAIL ? (
            <div className='w-100'>
              <div className='error-message'>
                <h3>{errorMessage}</h3>
                <div className='mt-2'>
                  <Button.Ripple color='primary' onClick={onClickGoBackHome}>
                    <FormattedMessage id='common.back' />
                  </Button.Ripple>
                </div>
              </div>
            </div>
          ) : ''
        )
      }
    </div>)
}


export default AutoLogin
